module.exports = __webpack_public_path__ + "img/ai-gray.6b5257c1.svg";